import { FRAME_LOADERS } from './generated/loaders';
import type { FrameSpec } from './frames';
import { FRAME_INDEX } from './generated';
export { FRAME_INDEX };
const pending = new Map<string, Promise<FrameSpec>>();
export function loadCatalogueFrame(id: string): Promise<FrameSpec> {
  const loader = FRAME_LOADERS[id];
  if (!Object.hasOwn(FRAME_LOADERS, id) || !loader) return Promise.reject(new Error(`Unknown frame: ${id}`));
  let promise = pending.get(id);
  if (!promise) {
    promise = loader().catch(error => { pending.delete(id); throw error; });
    pending.set(id, promise);
  }
  return promise;
}

/** A200: the catalogue frame sold under a Shopify product handle (ids and handles can differ). */
export function frameForHandle(handle: string | null | undefined): FrameSpec | undefined {
  if (!handle) return undefined;
  return FRAME_INDEX.find(f => f.productHandle === handle) ?? FRAME_INDEX.find(f => f.id === handle);
}
